"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagTL = function FlagTL(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54-122H-185.94a7.06,7.06,0,0,0-7.06,7.06V139.3a7.06,7.06,0,0,0,7.06,7.06H209.54a7.06,7.06,0,0,0,7.06-7.06V-114.94a7.06,7.06,0,0,0-7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.2,144.78,36.89,16.57a5,5,0,0,0,0-8.78L-190.2-120.42a6.94,6.94,0,0,0-2.8,5.48V139.3a6.94,6.94,0,0,0,2.8,5.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.81,144.38-36.46,17a6.31,6.31,0,0,0,0-9.72L-190.81-120a7,7,0,0,0-2.19,5.08V139.3a7,7,0,0,0,2.19,5.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-148.89-21l.67,25.41L-172,13.3a2.54,2.54,0,0,0,.16,4.81l24.38,7.21,1.07,25.41a2.54,2.54,0,0,0,4.63,1.33l14.4-21,24.48,6.83a2.53,2.53,0,0,0,2.7-4l-15.48-20.17L-101.65-7.4a2.54,2.54,0,0,0-3-3.8l-24,8.5-15.8-19.93A2.53,2.53,0,0,0-148.89-21Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagTL;
exports["default"] = _default;